import { Box, Flex } from "@chakra-ui/react";
import type { ReactNode } from "react";

import { INQUIRY_FAILED_STATUSES } from "@equidefi/shared";
import { Heading, Text } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";

export const SectionTitle = ({ children }: { children: string }) => (
  <Heading
    as="h3"
    fontSize="xs"
    fontWeight="bold"
    letterSpacing="wide"
    color="gray.700"
    textTransform="uppercase"
    m={0}>
    {children}
  </Heading>
);

export const Row = ({ label, value }: { label: string; value: ReactNode }) => (
  <Flex gap={2} py={1} align="baseline">
    <Text fontSize="sm" color="gray.700" mb="0">
      {label}:
    </Text>
    <Text fontSize="sm" mb="0">
      {value == null || value === "" ? "N/A" : value}
    </Text>
  </Flex>
);

export const VerificationResult = ({ passed, status }: { passed: boolean; status?: string }) => {
  const isFailedStatus = !!status && INQUIRY_FAILED_STATUSES.some((s) => s === status);
  const showPassed = passed && !isFailedStatus;
  return (
    <Flex align="center" gap="2">
      {showPassed ? (
        <>
          <Box color="equidefi.green">
            <Icon.Check size="1.25em" />
          </Box>
          <Text fontSize="sm" mb="0">
            Verification Passed
          </Text>
        </>
      ) : (
        <>
          <Box color="equidefi.red">
            <Icon.X size="1.25em" />
          </Box>
          <Text fontSize="sm" mb="0">
            Verification Failed
          </Text>
        </>
      )}
    </Flex>
  );
};
